import {
  GET_BANK_BRANCH_CODE,
  SET_BANK_BRANCH_CODE,
  SET_LEAD_SELECTED_ITEMS,
} from '@stores/lead/constants.js';

const setBankBranchCodeRequest = (payload, callback) => ({
  type: SET_BANK_BRANCH_CODE,
  payload,
  callback,
});

const getBankBranchCodeRequest = (payload, callback) => ({
  type: GET_BANK_BRANCH_CODE,
  payload,
  callback,
});

const setLeadSelectedItems = (payload) => ({
  type: SET_LEAD_SELECTED_ITEMS,
  payload,
});

export {
  setBankBranchCodeRequest,
  getBankBranchCodeRequest,
  setLeadSelectedItems,
};
